// Prevent single word wrapping in featured post title
// Ensures at least two words are on the second line if wrapping occurs
export default function preventSingleWordWrap() {
  const featuredTitle = document.querySelector('.gh-featured-post .gh-title');
  if (!featuredTitle) {
    return;
  }

  // Check if there's a link inside the title
  const titleLink = featuredTitle.querySelector('a.gh-title-link');
  const targetElement = titleLink || featuredTitle;

  // Store original text content
  const originalText = targetElement.textContent.trim();
  const words = originalText.split(/\s+/);
  
  // Need at least 2 words to join them
  if (words.length < 2) {
    return;
  }

  // Function to join last two words with non-breaking space
  const joinLastTwoWords = () => {
    // Make sure we have the element
    const title = document.querySelector('.gh-featured-post .gh-title');
    if (!title) {
      return;
    }
    
    // Check if there's a link inside the title
    const titleLink = title.querySelector('a.gh-title-link');
    const targetElement = titleLink || title;
    
    // Get current text (in case it changed)
    const currentText = targetElement.textContent.trim();
    const currentWords = currentText.split(/\s+/);
    
    if (currentWords.length < 2) {
      return;
    }
    
    // Get the last two words
    const lastWord = currentWords[currentWords.length - 1];
    const secondToLastWord = currentWords[currentWords.length - 2];
    const wordsBeforeLastTwo = currentWords.slice(0, -2);
    
    // Create new text with non-breaking space between last two words
    let newText;
    if (wordsBeforeLastTwo.length > 0) {
      newText = wordsBeforeLastTwo.join(' ') + ' ' + 
                secondToLastWord + '\u00A0' + lastWord; // Non-breaking space
    } else {
      newText = secondToLastWord + '\u00A0' + lastWord;
    }
    
    targetElement.textContent = newText;
  };
  
  // Run after a short delay to ensure DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      setTimeout(joinLastTwoWords, 100);
    });
  } else {
    setTimeout(joinLastTwoWords, 100);
  }
  
  // Re-run on resize (with debounce) in case content changes
  let resizeTimeout;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(joinLastTwoWords, 100);
  });
}

